import api from "../../../api/axios";

const MOTIVOS_DEFEITO_BASE = "/bases_estaleiro/motivos_defeito_novo";

export async function listarMotivosDefeitoEstaleiro({ q = "", ativo, limit = 100, offset = 0 } = {}) {
  const { data } = await api.get(`${MOTIVOS_DEFEITO_BASE}/listar`, {
    params: { q, ativo, limit, offset },
  });
  return Array.isArray(data?.data) ? data.data : [];
}

export async function cadastrarMotivoDefeitoEstaleiro(motivoDefeito) {
  const { data } = await api.post(`${MOTIVOS_DEFEITO_BASE}/cadastrar`, {
    motivo_defeito: motivoDefeito,
    ativo: 1,
  });
  return data?.data || null;
}

export async function editarMotivoDefeitoEstaleiro(id, motivoDefeito) {
  const { data } = await api.put(`${MOTIVOS_DEFEITO_BASE}/editar/${id}`, {
    motivo_defeito: motivoDefeito,
  });
  return data?.data || null;
}

export async function alterarStatusMotivoDefeitoEstaleiro(id, ativo) {
  const { data } = await api.patch(`${MOTIVOS_DEFEITO_BASE}/alterar-ativo/${id}`, {
    ativo: Number(ativo) ? 1 : 0,
  });
  return data?.data || null;
}

export async function excluirMotivoDefeitoEstaleiro(id) {
  const { data } = await api.delete(`${MOTIVOS_DEFEITO_BASE}/excluir/${id}`);
  return data?.data || null;
}
